import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ApprovedExpert from '../../../widgets/approvedExpert/ApprovedExpert'
import ApproveExpertWidget from '../../../widgets/approveExpertWidget/ApproveExpertWidget'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchema } from '../../../redux/actions/approveExpert'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { startLoading, doneLoading } from '../../../utils/loading'

export default function ApproveExpert() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchema(projectId)
      setSchema(_schema.model)
    } catch (e) {}
    doneLoading()
    setIsLoading(false)
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.ProjectInfo} />
      <br />
      <ApprovedExpert schema={schema.forms?.ReviewerApproveList} />
      <br />
      <ApproveExpertWidget
        schema={schema.forms?.ReviewerSelectList}
        onUpdateSchema={() => handleGetSchema()}
      />
      <br />
    </SidebarProposal>
  )
}
